

// trim string to specified length
export function truncateText(unsanitizedOriginalText, charLimit, ignoreWordBoundary) { // eslint-disable-line
  // sanitize by trimming and removing consecutive spaces
  const originalText = unsanitizedOriginalText.trim().replace(/\s{2,}/g, ' ');

  if (charLimit < 3 || !originalText || originalText.length <= charLimit) {
    return originalText;
  }

  // if we're ignoring word boundaries, we don't have to do anything fancy
  // just chop it off at the limit and make sure we don't end with whitespace
  if (ignoreWordBoundary) {
    return `${originalText.substring(0, charLimit - 3).trim()}...`;
  }

  const truncatedText = originalText.substring(0, charLimit - 2); // subtract 3 to make room for ellipsis, but add 1 to catch whitespace if we happen to end on a word boundary
  const lastSpaceIndex = truncatedText.lastIndexOf(' ');

  if (lastSpaceIndex <= 0) {
    return `${truncatedText.substring(0, truncatedText.length - 1)}...`;
  }

  return `${truncatedText.substring(0, lastSpaceIndex)}...`;
}



/** WEBPACK FOOTER **
 ** ./src/util/textUtil.js
 **/